'use client';

/**
 * SysObeyaExplorerModuleSummaryCard — explorer report-picker for
 * `sel:module_summary`.
 *
 * Click row → dispatches `setExplorerSelection('module_summary')`.
 * Click kebab → opens the per-report menu (Copy report / Download
 * capture). The capture envelope bundles every observed BFF payload
 * (the system_obeya_view + system_obeya_synopsis responses) AND the
 * rendered scene mirror into one file — no separate JSON / scene
 * downloads are needed.
 *
 * Chrome (label + description + menu action text) reads from
 * `response.labels` shipped with the `system_obeya_view` strategy
 * — deduped by React Query so the canvas cards and this card share
 * a single round-trip.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_explorer_module_summary"
 * @see klyde_edge/ui_config/labels/system_obeya.py — sel_module_summary_*, action_download_capture
 */

import { LayoutDashboard } from 'lucide-react';
import { useSystemObeyaView } from '@/components/canvas/cards/system_obeya/use-system-obeya-view';
import { ReportTile } from './report-tile';

const VIEW_NAME = 'module_summary';

export function SysObeyaExplorerModuleSummaryCard() {
  const { data } = useSystemObeyaView(VIEW_NAME);
  const L = data?.labels ?? {};

  return (
    <ReportTile
      selection={VIEW_NAME}
      label={L.sel_module_summary_label ?? ''}
      description={L.sel_module_summary_description}
      Icon={LayoutDashboard}
      copyReportLabel={L.action_copy_report}
      downloadCaptureLabel={L.action_download_capture}
      menuLabel={L.report_menu_label}
      mode="mode9"
      contentKey="sys_obeya_explorer_module_summary"
    />
  );
}
